(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iw-acdc-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-combo-variant]');
  if (!select) return;
  const root = select.closest('[data-iw-combo-purchase]');
  const option = select.selectedOptions[0];
  if (!root || !option) return;
  root.querySelector('[data-combo-price]').textContent = option.dataset.price;
  root.querySelector('[data-combo-net]').textContent = option.dataset.net;
  root.querySelector('[data-combo-stock]').textContent = option.dataset.stockLabel;
  const quantity = root.querySelector('[data-combo-quantity]');
  const maximum = Math.max(1, Number(option.dataset.stock));
  quantity.max = String(maximum);
  if (Number(quantity.value) > maximum) quantity.value = String(maximum);
  const button = root.querySelector('[data-combo-buy]');
  const available = option.dataset.available === 'true';
  button.disabled = !available;
  button.textContent = available ? button.dataset.buy : button.dataset.soldOut;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iw-stingray-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('iw-stingray-player')) {
  customElements.define('iw-stingray-player', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => { if (this.isConnected && !this.abort) this.init(); });
    }
    init() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.iw-stingray-player__toggle');
      this.soundButton = this.querySelector('.iw-stingray-player__sound');
      this.fullscreenButton = this.querySelector('.iw-stingray-player__fullscreen');
      if (!this.video || !this.toggle) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.userPaused = false;
      this.userStarted = false;
      this.inView = false;
      this.sourceSet = false;
      this.video.controls = false;
      this.video.muted = true;
      this.soundButton.hidden = false;
      this.soundButton.addEventListener('click', () => {
        const enableSound = this.video.muted || this.video.volume === 0;
        this.video.muted = !enableSound;
        if (enableSound) {
          if (this.video.volume === 0) this.video.volume = 1;
          this.userPaused = false;
          this.userStarted = true;
          this.play();
        }
        this.updateSound();
      }, options);
      this.video.addEventListener('volumechange', () => this.updateSound(), options);
      this.querySelector('.iw-stingray-player__toolbar').hidden = false;
      this.querySelector('progress').hidden = false;
      this.fullscreenButton.hidden = !(document.fullscreenEnabled && this.requestFullscreen) && !this.video.webkitEnterFullscreen;
      this.toggle.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.userStarted = true;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.fullscreenButton.addEventListener('click', () => {
        if (document.fullscreenElement === this) document.exitFullscreen().catch(() => {});
        else if (document.fullscreenEnabled && this.requestFullscreen) this.requestFullscreen().catch(() => this.nativeControls());
        else if (this.video.webkitEnterFullscreen) {
          try { this.video.webkitEnterFullscreen(); } catch { this.nativeControls(); }
        }
      }, options);
      document.addEventListener('fullscreenchange', () => {
        this.querySelector('[data-fullscreen-label]').textContent = document.fullscreenElement === this ? this.dataset.closeFullscreenLabel : this.dataset.fullscreenLabel;
      }, options);
      ['play', 'pause', 'ended'].forEach(event => this.video.addEventListener(event, () => this.update(), options));
      this.video.addEventListener('timeupdate', () => this.updateTime(), options);
      this.video.addEventListener('loadedmetadata', () => this.updateTime(), options);
      this.video.addEventListener('error', () => {
        this.querySelector('.iw-stingray-player__error').hidden = false;
        this.update();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.userStarted = false;
        this.sync();
      }, options);
      if (this.connection?.addEventListener) this.connection.addEventListener('change', () => this.sync(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
          this.sync();
        }, { threshold: [0, 0.35] });
        this.observer.observe(this.video);
      }
      this.update();
      this.updateSound();
    }
    autoAllowed() {
      return this.dataset.autoplay === 'true' && !this.motion.matches && !this.connection?.saveData && !/^(slow-)?2g$/.test(this.connection?.effectiveType || '');
    }
    nativeControls() {
      this.video.controls = true;
      this.fullscreenButton.hidden = true;
    }
    play() {
      if (!this.sourceSet) {
        const small = matchMedia('(max-width: 900px)').matches || this.connection?.saveData || /^(slow-)?2g$/.test(this.connection?.effectiveType || '');
        this.video.src = small ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        this.sourceSet = true;
      }
      this.video.play().catch(() => this.update());
    }
    sync() {
      if (document.hidden || !this.inView) this.video.pause();
      else if (!this.userPaused && (this.userStarted || this.autoAllowed())) this.play();
      else this.video.pause();
    }
    update() {
      const playing = !this.video.paused && !this.video.ended;
      this.querySelector('[data-playback-label]').textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.querySelector('.iw-stingray-player__play-icon').toggleAttribute('hidden', playing);
      this.querySelector('.iw-stingray-player__pause-icon').toggleAttribute('hidden', !playing);
    }
    updateTime() {
      const duration = this.video.duration;
      if (!Number.isFinite(duration) || !duration) return;
      const format = value => `${String(Math.floor(value / 60)).padStart(2, '0')}:${String(Math.floor(value % 60)).padStart(2, '0')}`;
      this.querySelector('.iw-stingray-player__time').textContent = `${format(this.video.currentTime)} / ${format(duration)}`;
      this.querySelector('progress').value = this.video.currentTime / duration * 100;
    }
    updateSound() {
      const muted = this.video.muted || this.video.volume === 0;
      this.querySelector('[data-sound-label]').textContent = muted ? this.dataset.soundOnLabel : this.dataset.soundOffLabel;
      this.querySelector('[data-sound-muted]').toggleAttribute('hidden', !muted);
      this.querySelector('[data-sound-audible]').toggleAttribute('hidden', muted);
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
